import { CompanySubscriptionDTO } from './dtos/CompanySubscriptionDTO';

import { setupApi } from '.';

export async function loadSubscriptionByDocument(
  document: string,
  ctx = undefined
): Promise<CompanySubscriptionDTO> {
  const response = await setupApi(ctx).get(
    `/subscriptions/document/${document}`
  );

  return response.data;
}

export async function downloadSubscriptionInvoice(
  companyId: string,
  invoiceId: string,
  subscriptionId: string
): Promise<string> {
  const response = await setupApi().get(
    `/companies/${companyId}/subscription/${subscriptionId}/invoices/${invoiceId}/download`
  );
  return response.data;
}

export async function getInvoiceHtml(
  companyId: string,
  invoiceId: string,
  subscriptionId: string
): Promise<string> {
  const response = await setupApi().get(
    `/companies/${companyId}/subscription/${subscriptionId}/invoices/${invoiceId}/html`
  );
  return response.data;
}
